import React from 'react';
import PropTypes from 'prop-types';
import pageLoadingIndicator from '@mapbox/mr-ui/page-loading-indicator';
import {
  addRouteChangeStartListener,
  addRouteChangeEndListener
} from '@mapbox/batfish/modules/route-change-listeners';
import { AppContext } from '../context.js';

addRouteChangeStartListener(() => {
  pageLoadingIndicator.start();
});
addRouteChangeEndListener(() => {
  pageLoadingIndicator.end();
});

if (typeof window !== 'undefined') {
  import(
    /* webpackChunkName: "assembly-js" */ '@mapbox/mbx-assembly/dist/assembly.js'
  );
}

class ApplicationWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      preferredLanguage: {
        ios: 'swift',
        android: 'java',
        react: 'hooks'
      },
      userAccessToken: undefined,
      userName: undefined
    };
  }

  componentDidMount() {
    MapboxPageShell.afterUserCheck(() => {
      this.setState({
        userAccessToken: MapboxPageShell.getUserPublicAccessToken(),
        userName: MapboxPageShell.getUser()
          ? MapboxPageShell.getUser().id
          : undefined
      });
    });
  }

  render() {
    const context = {
      languages: {
        ios: [
          {
            label: 'Swift',
            value: 'swift'
          },
          {
            label: 'Objective-C',
            value: 'objectiveC'
          }
        ],
        android: [
          {
            label: 'Java',
            value: 'java'
          },
          {
            label: 'Kotlin',
            value: 'kotlin'
          }
        ],
        react: [
          {
            label: 'Hooks',
            value: 'hooks'
          },
          {
            label: 'Classes',
            value: 'classes'
          }
        ]
      },
      preferredLanguage: {
        ios: this.state.preferredLanguage.ios,
        android: this.state.preferredLanguage.android,
        react: this.state.preferredLanguage.react
      },
      changeLanguage: {
        ios: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              ios: nextLang
            }
          });
        },
        android: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              android: nextLang
            }
          });
        },
        react: (nextLang) => {
          this.setState({
            preferredLanguage: {
              ...this.state.preferredLanguage,
              react: nextLang
            }
          });
        }
      },
      userAccessToken: this.state.userAccessToken,
      userName: this.state.userName
    };
    return (
      <AppContext.Provider value={context}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

ApplicationWrapper.propTypes = {
  children: PropTypes.node
};

export default ApplicationWrapper;
